import {Course} from 'src/redux/lists';
import req from 'shared/req';

export interface CourseListings {
  apCourses: Course[];
  certificationCourses: Course[];
  dualEnrollmentCourses: Course[];
  ibCourses: Course[];
  normalCourses: Course[];
}

export default class CoursesService {
  static async getCourses(): Promise<CourseListings> {
    return req({
      url: '/v1/lists/courses',
    });
  }
}
